
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideBarContainer.scss';

class SideBarContainer extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    styl: PropTypes.string,
    children: PropTypes.array.isRequired,
  };

  render() {
    return (
      <div style={{ width: `${this.props.width}%`, position: 'relative', marginTop: '20px', marginLeft: '10px' }} className={this.props.styl || 'side-bar-container'}>
        {this.props.children}
      </div>
    );
  }
}

export default withStyles(s)(SideBarContainer);



// WEBPACK FOOTER //
// src/components/SideBarMenu/SideBarContainer/SideBarContainer.js